export default __webpack_public_path__ + "static/media/36I-102797_-15935_0.e661cb8a.jpg";